<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
    fill="currentColor"
  >
    <path d="M480 694q-8 0-15-2.5t-13-8.5L267 498q-11-11-10.5-27.5T268 443q11-11 28-11t28 11l156 156 157-157q11-11 27.5-10.5T692 443q11 11 11 28t-11 28L508 683q-6 6-13 8.5t-15 2.5Z" />
  </svg>
</template>

<script>
  export default {
    name: 'Chevron'
  }
</script>
